import { DatePicker } from '@monorepo/shared/componentsV2/dateAndTimePickers';
import { format, isValid, parse } from 'date-fns';
import {
  FORM_SUBMISSION_FIELD_DATE_FORMAT,
  NullableDate,
} from 'mapistry-shared';
import React from 'react';
import { useField } from 'react-final-form';
import styled from 'styled-components';
import { type ConditionalFieldValueInputProps } from './ConditionalFieldValueFactory';
import {
  conditionalDateTimePickerStyles,
  inputWithWhiteBackground,
} from './styled';

const StyledDatePicker = styled(DatePicker)<{ $isErrorTextShown: boolean }>`
  ${inputWithWhiteBackground}
  ${conditionalDateTimePickerStyles}
`;

export function ConditionalDateField({
  name,
  ...inputFieldProps
}: ConditionalFieldValueInputProps['inputFieldProps']) {
  const {
    input: { onChange, value },
    meta,
  } = useField<string>(name);

  const handleChange = ({
    target: { value: newValue },
  }: {
    target: { value: NullableDate };
  }) => {
    if (newValue && isValid(newValue)) {
      onChange(format(newValue, FORM_SUBMISSION_FIELD_DATE_FORMAT));
    }
  };

  const hasError = (meta.touched || meta.modified) && !!meta.error;

  return (
    <StyledDatePicker
      {...inputFieldProps}
      name={name}
      onChange={handleChange}
      value={
        value
          ? parse(value, FORM_SUBMISSION_FIELD_DATE_FORMAT, new Date())
          : null
      }
      dontSaveSpaceForErrorText
      $isErrorTextShown={!!hasError}
    />
  );
}
